export default __webpack_public_path__ + "static/LandBlock2-992825378cbf079cf931c4ec50afad96.png";